export const PRICE_CODE_STATUS_NEW = 'NEW';
export const PRICE_LEVEL_STATUS_NEW = 'NEW';

export const priceLevelErrors = {
  SELECTED_NEW_PRICE_LEVEL_START_TIME_AFTER_CURRENT_PRICE_LEVEL_START_TIME:
    'Selected Price Level Access Start Time must be After Access Start Time',
  SELECTED_NEW_PRICE_LEVEL_START_TIME_BEFORE_PRICE_LEVEL_END_TIME:
    'Price Level Access Start Time must be before Access End Time',
  SELECTED_NEW_PRICE_LEVEL_END_TIME_BEFORE_CURRENT_PRICE_LEVEL_END_TIME:
    'Selected Price Level Access End Time Must Be Before Access End Time',
  DATES_COMPLETED_ERROR: 'You Must Select Both Times, To Save Price Level',
};



// WEBPACK FOOTER //
// ./src/routes/EventDetails/routes/admissions/constants/status.js